const messages = {
  title: "Primljena pošta",
  desc: "Ovdje ćete pronaći važne obavijesti i novosti.",
  newMessages: "Nove poruke u primljenoj pošti",
  link: "Prikaži poruke",
  showMessages: "Prikaži poruke",
  message: {
    sender: "Pošiljalac",
    thread: "Predmet",
    date: "Datum",
  },
  sender: {
    system: "BRIDGESTONE PLUS",
    admin: "Admin",
  },
  back: "Nazad",
  time: {
    secondsAgo: "prije {time} sekundi",
    minutesAgo: "prije {time} minuta",
    hoursAgo: "prije {time} sati",
    daysAgo: "prije {time} dana",
  },
};
export default {
  messages,
};
